import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import ColumnEnum from '@/global/components/DataGrid/utils/columEnum'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { StatusCompetencia as Status } from '@acme/core'
import dayjs from 'dayjs'
import { InfoIcon } from 'lucide-react'
import { StatusCompetencia } from '../atoms/status'

const COLUMN_RESPONSAVEL: GridColDefPro = {
    flex: 1,
    field: 'responsavel',
    headerName: 'Responsável',
    valueGetter: ({
        row: {
            Usuario: { email },
        },
    }) => email,
}

const COLUMN_HORA = (status: Status) =>
    ({
        width: 150,
        headerName:
            status === 'ABERTA' ? 'Hora de abertura' : 'Hora do fechamento',
        field: status === 'ABERTA' ? 'horaAbertura' : 'horaFechamento',
        align: 'center',
        type: 'time',
        valueGetter: ({ value }) =>
            dayjs
                .utc(value, 'HH:mm')
                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .format('HH:mm'),
    }) as GridColDefPro

const COLUMN_DIA = (status: Status) =>
    ({
        width: 150,
        headerName:
            status === 'ABERTA' ? 'Dia da abertura' : 'Dia do fechamento',
        field: status === 'ABERTA' ? 'dataAbertura' : 'dataFechamento',
        align: 'center',
        type: 'date',
        valueGetter: ({ row }) => row.dataFechamento,
        valueFormatter: ({ value }) => dayjs.utc(value).format('DD/MM/YYYY'),
    }) as GridColDefPro

const COLUMN_COMPETENCIA: GridColDefPro = {
    width: 150,
    headerName: 'Competência',
    align: 'center',
    field: 'competencia',
    valueGetter: ({ value }) => String(value).split('-').reverse().join('/'),
}

const COLUMN_STATUS: GridColDefPro = {
    width: 125,
    align: 'center',
    field: 'status',
    headerName: 'Status',
    type: new ColumnEnum([
        { value: 'ABERTA', label: 'Aberta' },
        { value: 'FECHADA', label: 'Fechada' },
    ]),
    renderCell: StatusCompetencia,
}

const COLUMN_DETALHES: GridColDefPro = {
    ...optionsColumn,
    field: '__detalhes',
    renderCell: ({ id }) => (
        <IconButton title="Detalhes" href={`${id}/detalhes`}>
            <InfoIcon />
        </IconButton>
    ),
}

export const columnsFechamento: GridColDefPro[] = [
    COLUMN_RESPONSAVEL,
    COLUMN_HORA('FECHADA'),
    COLUMN_DIA('FECHADA'),
    COLUMN_COMPETENCIA,
    COLUMN_STATUS,
    COLUMN_DETALHES,
]

export const columnsAbertura: GridColDefPro[] = [
    COLUMN_RESPONSAVEL,
    COLUMN_HORA('ABERTA'),
    COLUMN_DIA('ABERTA'),
    COLUMN_COMPETENCIA,
    COLUMN_STATUS,
    COLUMN_DETALHES,
]
